// services/empresas.js
import axiosInstance from './axiosInstance';

const EMPRESAS_API_URL = '/empresas';

const empresasService = {
  async get(combustivel = null) {
    try {
      let url = `${EMPRESAS_API_URL}/get.php`;
      if (combustivel) {
        url += '?combustivel=true';
      }
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getById(idempresa) {
    try {
      const response = await axiosInstance.get(`${EMPRESAS_API_URL}/getById.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async set(empresaData) {
    try {
      const response = await axiosInstance.post(`${EMPRESAS_API_URL}/set.php`, empresaData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa) {
    try {
      const response = await axiosInstance.get(`${EMPRESAS_API_URL}/unset.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default empresasService;
